import { QueryResult } from '@apollo/client';
import { useMemo } from 'react';
import { useLocation } from 'react-router';
import { TEDEKBokforderVariantEnum } from '../../../../../../globalQueryTypes';
import {
  IFieldValidation,
  IValidateFn,
} from '../../../../_Common/Components/BusinessCollectionComponents/BusinessDataForm/Utils/BusinessDataFormUtils';
import { getBokforderVariant } from '../Components/BokforderContext/BokforderContextManager';
import {
  BokforderSettingsQuery,
  BokforderSettingsQueryVariables,
} from '../Queries/BokforderSettingsQuery/_QueryTypes/BokforderSettingsQuery';
import { BokforderType } from '../Queries/_QueryTypes/BokforderType';
import { parseParamsValues } from '../Utils/BokforderKonteringUtils';

const useValidateBokKontering = (
  bokforderSettingsQuery: QueryResult<
    BokforderSettingsQuery,
    BokforderSettingsQueryVariables
  >
): IValidateFn<BokforderType> => {
  const location = useLocation();

  return useMemo(
    () =>
      ({ currentValues, touched, data }) => {
        const errors: IFieldValidation[] = [];
        const bfoType = getBokforderVariant(data, location.search);

        if (bfoType !== TEDEKBokforderVariantEnum.MALL) {
          return [];
        }

        const paramValues = parseParamsValues(currentValues.PARAMVALUES ?? '');
        const currentTemplate =
          bokforderSettingsQuery.data?.db?.EKBokforingsmall_All?.find(
            template =>
              template.id === currentValues._Associations?.Bokforingsmall?.id
          );
        const usesBokfBelopp =
          !currentTemplate?.EXKLUDERA_BELOPP && !bokforderSettingsQuery.loading;

        //Validera belopp
        if (
          usesBokfBelopp &&
          (paramValues.BOKF_BELOPP == null ||
            paramValues.BOKF_BELOPP?.trim() == '')
        ) {
          const bokfBeloppError: IFieldValidation = {
            fieldName:
              touched.BOKF_BELOPP != null ? 'BELOPP' : 'MISSING_BELOPP',
            message: 'Fältet belopp måste anges',
            type: 'Error',
          };

          errors.push(bokfBeloppError);
        }

        if (
          currentValues?.BOKF_DATUM == null ||
          currentValues?.BOKF_DATUM == ''
        ) {
          const missingDateError: IFieldValidation = {
            fieldName: 'BOKF_DATUM',
            type: 'RequiredValueHint',
            showAsHint: !touched.BOKF_DATUM,
          };
          errors.push(missingDateError);
        }

        //Validera params

        for (const [paramKey, paramValue] of Object.entries(paramValues)) {
          if (paramValue == null || paramValue == '') {
            const paramWarning: IFieldValidation = {
              fieldName:
                touched?.[paramKey] != null ? paramKey : `MISSING_${paramKey}`,
              message: `Glömt att fylla i fältet?`,
              type: 'Warning',
            };
            errors.push(paramWarning);
          }
        }

        return errors;
      },
    [
      bokforderSettingsQuery.data?.db?.EKBokforingsmall_All,
      bokforderSettingsQuery.loading,
      location.search,
    ]
  );
};

export default useValidateBokKontering;
